module.exports = __webpack_public_path__ + "assets/idling.52a9be93.svg";